import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { initAnalytics } from "./lib/analytics.js";
import { createApi } from "./lib/api.js";
import { createRoutes } from "./router.jsx";
import "@/styles/globals.css";

initAnalytics();

const router = createBrowserRouter(createRoutes(createApi()));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
